import {ContactField} from '@target-web/leadads-form-view';
import {createRef} from 'react';
import {validations} from 'utils/validation';

export class FormFieldController {
    private _value: string;
    private _isFilled: boolean = false;
    public isValid: boolean = true;
    public name: ContactField;
    public error?: string;
    private _isFocused: boolean = false;
    public hash?: string; // используется для телефона и почты
    public ref: React.RefObject<HTMLElement | null> = createRef();
    private refreshF: () => void;
    public onAnalyticEvent?: () => void;

    constructor(params: {initialValue?: string; refreshF: () => void; fieldName: ContactField}) {
        this._value = params.initialValue || '';
        this.refreshF = params.refreshF;
        this.name = params.fieldName;
    }

    private set value(v: string) {
        this._value = v;
        this.refreshF();
    }
    public get value() {
        return this._value;
    }

    private set isFilled(v: boolean) {
        this._isFilled = v;
        if (!v) {
            this._value = '';
        }
        this.refreshF();
    }
    public get isFilled() {
        return this._isFilled;
    }

    private set isFocused(v: boolean) {
        this._isFocused = v;
        this.refreshF();
    }
    public get isFocused() {
        return this._isFocused;
    }

    public onChange = (value: string) => {
        this.value = value;
        if (!this.isValid) {
            this.validate();
        }
    };

    public fill = (params: {value: string; hash?: string}) => {
        this._isFilled = ['phone', 'email', 'social_media_profile'].includes(this.name);
        this.value = params.value;
        if (params.hash) {
            this.hash = params.hash;
        }
    };

    public changeFilled = () => {
        this.isFilled = false;
    };

    public onFocus = () => {
        this.isFocused = true;
    };

    public onBlur = () => {
        this.isFocused = false;
        this.validate();
    };

    public validate = () => {
        const validation = validations[this.name];
        if (!validation) return;
        try {
            if (!this.isFilled) {
                // скипаем проверку автозаполненных полей
                validation(this.value);
            }
            this.isValid = true;
            delete this.error;
        } catch (e) {
            if (e instanceof Error) {
                this.isValid = false;
                this.error = e.message;
            }
        }
    };
}
